<template>
  <ModalConfirmAction
    rootClass="ModalUnpublish"
    :isOpen="isOpen"
    :isLoading="isLoading"
    title="Unpublish webpage"
    lead="This webpage will be taken offline and its shared link will stop working."
    bannerTheme="neutral"
    bannerIcon="lockOpenRegular"
    bannerTitle="Access will be removed"
    bannerDescription="You can publish this webpage again later."
    confirmLabel="Unpublish now"
    @close="emit('close')"
    @confirm="emit('confirm')"
  />
</template>

<script lang="ts" setup>
import ModalConfirmAction from '@/views/components/modals/ModalConfirmAction.vue'

// Unpublish is reversible, so the banner reassures (neutral) rather than alarms.
defineProps<{
  isOpen: boolean
  isLoading?: boolean
}>()

const emit = defineEmits<{
  close: []
  confirm: []
}>()
</script>
